import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { applyMiddleware, createStore, compose } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'

// Import the index reducer and sagas
import IndexReducer from './index-reducer'
import rootSagas from './index-sagas'

// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'

// Containers
import Full from './containers/Full/'

// Views
import Login from './views/Pages/Login'
import LoginIssue from './views/Pages/LoginIssue'
import ResetPassword from './views/Pages/ResetPassword'
import ResendConfirmAcc from './views/Pages/ResendConfirmAcc'
import ForgotPassword from './views/Pages/ResendResetPwCode'
import ConfirmationRegist from './views/Pages/ActiveAcc'
import LoginMfa from './views/Pages/LoginMfa'
import Register from './views/Pages/Register/'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'
import Page403 from './views/Pages/Page403/'

// Setup the middleware to watch between the Reducers and the Actions
const sagaMiddleware = createSagaMiddleware()

/*eslint-disable */
const composeSetup = process.env.NODE_ENV !== 'production' && typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose
/*eslint-enable */

const store = createStore(
  IndexReducer,
  composeSetup(applyMiddleware(sagaMiddleware)), // allows redux devtools to watch sagas
)

// Begin our Index Saga
sagaMiddleware.run(rootSagas, store)

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <Switch>
        <Route exact path="/reconfirmation/:callback?" name="Re-confirmation account" component={ResendConfirmAcc}/>
        <Route exact path="/confirmation-acc/:confirmation_token?" name="Confirmation account" component={ConfirmationRegist}/>
        <Route exact path="/login/:callback?" name="Login to systemo" component={Login}/>
        <Route exact path="/loginMfa/:callback?" name="2FA authentication" component={LoginMfa}/>
        <Route exact path="/login-issue/:callback?" name="Login Troubleshooting" component={LoginIssue}/>
        <Route exact path="/forgotPassword/:callback?" name="Re-confirmation account" component={ForgotPassword}/>
        <Route exact path="/resetPw/:reset_password_token?" name="Reset your password" component={ResetPassword}/>
        <Route exact path="/register" name="Register new account" component={Register}/>
        <Route exact path="/404" name="Page 404" component={Page404}/>
        <Route exact path="/500" name="Page 500" component={Page500}/>
        <Route exact path="/403" name="Page 500" component={Page403}/>
        <Route path="/" name="Home" component={Full}/>
      </Switch>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js